import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import jsonAppData from 'utils/jsonAppData';
import { getCurrentDate } from 'utils';
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { PdfGlassDocument } from 'components/PdfComponents';
import { ConfigurationDataContext, GlassStructureContext } from 'context/configuration';
import { UiContext } from 'context/ui';
import { AppDataContext } from 'context/appData';

const GlassConfigEditOptions = ({
	configurationData,
	glassTypeId,
	showPrice,
	freezerRef = null,
}) => {
	const { t } = useTranslation('commonConfigurationAction');
	const { themeSettings } = useContext(AppDataContext);
	const { showPopupByKey } = useContext(UiContext);
	const { editConfiguration, oversizedGlassFields } = useContext(ConfigurationDataContext);
	const { uiHandlerRef } = useContext(GlassStructureContext);
	const [pdfLoading, setPdfLoading] = useState(false);

	const removeGlassItem = () => {
		showPopupByKey('genericWarning', {
			title: t('notifications:confirmationOfGlassDeletion'),
			confirmDialog: isConfirmed =>
				isConfirmed && freezerRef.current.emit('removeGlassType', { glassTypeId }),
		});
	};

	const editGlassItem = () => {
		const glassData = configurationData.glassTypes.find(o => o.id === glassTypeId);
		if (glassData) {
			showPopupByKey('genericWarning', {
				title: t('notifications:confirmationOfGlassEdit'),
				confirmDialog: isConfirmed => isConfirmed && editConfiguration(glassData),
			});
		}
	};

	const generatePdf = async () => {
		const currentDate = getCurrentDate();
		const documentFileName = t('configurationDotPdfFmt').replace('{date}', currentDate);
		const glassTypeIndex = configurationData.glassTypes.findIndex(o => o.id === glassTypeId);
		const glassData = configurationData.glassTypes[glassTypeIndex];
		if (glassData) {
			setPdfLoading(true);
			const { priceVolumeCat } = configurationData.totals.totalGlassSizesSum;
			const totalValues = configurationData.totals.totalGlassSizes[glassTypeIndex];
			const pdfDocument = (
				<PdfGlassDocument
					glassData={glassData}
					contactInfo={themeSettings.contact_info}
					totalValues={totalValues}
					showPrice={showPrice}
					priceVolumeCat={priceVolumeCat}
					oversizedGlassFields={oversizedGlassFields}
					uiHandlerRef={uiHandlerRef}
				/>
			);
			const blob = await pdf(pdfDocument).toBlob();
			setPdfLoading(false);
			saveAs(blob, documentFileName);
		}
	};

	const onClickOptionHandler = action => {
		if (action === 'delete') {
			removeGlassItem();
		} else if (action === 'edit') {
			editGlassItem();
		} else if (action === 'saveAsPdf') {
			generatePdf();
		}
	};

	return (
		<ul className="glass_config_edit_options">
			{jsonAppData.glassConfigEditOptions.map(({ label }, index) => {
				return (
					<li className="glass_config_edit_options__item" key={index}>
						{label === 'saveAsPdf' && pdfLoading ? (
							<button className="glass_config_edit_options__button" type="submit" disabled>
								{t('creatingPdf')}
							</button>
						) : (
							<button
								className="glass_config_edit_options__button"
								type="submit"
								onClick={e => {
									e.stopPropagation();
									onClickOptionHandler(label);
								}}
							>
								{t(label)}
							</button>
						)}
					</li>
				);
			})}
		</ul>
	);
};

export default GlassConfigEditOptions;
